import React from 'react'
import { observer } from 'mobx-react-lite'
import IconButton from '@mui/material/IconButton'
import NotificationsIcon from '@mui/icons-material/NotificationsOutlined';
import { useMainContainerStore } from '../MainContainerStore'
import Badge from '@mui/material/Badge'
import { useNotificationsStore } from './NotificationsStore'
import { themeConfig }from '@gap/shared/theme';

export default observer(function NotificationsToggler() {
   const mainContainerStore = useMainContainerStore()
   const notificationsStore = useNotificationsStore()

   return <IconButton
      ref={notificationsStore.notificationToggleRef}
      color="inherit"
      onClick={mainContainerStore.notificationsState.open}>
      <Badge
         variant="dot"
         overlap="circular"
         invisible={!notificationsStore.unreadNotificationCount}
         sx={{
            "& .MuiBadge-dot": {
               transform: "translate(0%, 160%)",
               backgroundColor: themeConfig.passion
            }
         }}>
         <NotificationsIcon />
      </Badge>
   </IconButton>
})
